import { api } from '../client'
import { ENDPOINTS } from '../config'
import { BranchRecord } from '../types'

export const BranchesService = {
    list: () => api.get<BranchRecord[]>(ENDPOINTS.BRANCHES.LIST),
    byId: (id: string) => api.get<BranchRecord>(ENDPOINTS.BRANCHES.BY_ID(id))
}
